export default {
  primary: "#3f6ee3",
};



// WEBPACK FOOTER //
// ./src/constants/colors.js